export const REQUEST_ORIGINS = {
  FRONTEND_REACT: "FRONTEND_REACT",
  MI_AGENT: "MI_AGENT",
  REPORT_AGENT: "REPORT_AGENT",
  ASKNEEDL_AGENT: "ASKNEEDL_AGENT",
  ASKNEEDL_AGENT_MSQUARED_HUB: "ASKNEEDL_AGENT_MSQUARED_HUB",
  ASKNEEDL_AGENT_ICRA_RESEARCH_ASSIST: "ASKNEEDL_AGENT_ICRA_RESEARCH_ASSIST",
  RESEARCH_ASSIST: "RESEARCH_ASSIST",
  ADMIN_TOOL: "ADMIN_TOOL",
  CONSOLE: "CONSOLE",
  AUTO_DD: "AUTO_DD",
  K8S_CONSOLE: "K8S_CONSOLE",
  OPERATIONS_DASHBOARD: "OPERATIONS_DASHBOARD",
  AUTO_DD_PROTOTYPE: "AUTO_DD_PROTOTYPE",
} as const;

type RequestOrigin = (typeof REQUEST_ORIGINS)[keyof typeof REQUEST_ORIGINS];

const REQUEST_ORIGIN_TO_ROUTE: Record<RequestOrigin, string> = {
  [REQUEST_ORIGINS.FRONTEND_REACT]: "/",
  [REQUEST_ORIGINS.MI_AGENT]: "/market-intelligence/",
  [REQUEST_ORIGINS.REPORT_AGENT]: "/report-agent/",
  [REQUEST_ORIGINS.ASKNEEDL_AGENT]: "/askneedl/",
  [REQUEST_ORIGINS.ASKNEEDL_AGENT_MSQUARED_HUB]: "/app/attribution-gpt/",
  [REQUEST_ORIGINS.ASKNEEDL_AGENT_ICRA_RESEARCH_ASSIST]: "/",
  [REQUEST_ORIGINS.RESEARCH_ASSIST]: "/research-assist/",
  [REQUEST_ORIGINS.ADMIN_TOOL]: "/admin/",
  [REQUEST_ORIGINS.CONSOLE]: "/console/",
  [REQUEST_ORIGINS.AUTO_DD]: "/ai-due-diligence/",
  [REQUEST_ORIGINS.K8S_CONSOLE]: "/k8s-console/",
  [REQUEST_ORIGINS.OPERATIONS_DASHBOARD]: "/operations-dashboard/",
  [REQUEST_ORIGINS.AUTO_DD_PROTOTYPE]: "/auto-dd-prototype/",
};

const STORAGE_KEY = "request-origin";

export const setRequestOrigin = (origin: RequestOrigin) => {
  sessionStorage.setItem(STORAGE_KEY, origin);
};

export const getRequestOrigin = (): RequestOrigin => {
  return (
    (sessionStorage.getItem(STORAGE_KEY) as RequestOrigin) ||
    REQUEST_ORIGINS.FRONTEND_REACT
  );
};

export const getRedirectRoute = (): string => {
  const origin = getRequestOrigin();
  return REQUEST_ORIGIN_TO_ROUTE[origin] || "/";
};
